module.exports = __webpack_public_path__ + "static/media/login-img.b37b05a7.png";